<app-unified-header title="Download" defaultHref="/help"></app-unified-header>
<ion-content>
  <ion-item *ngFor="let pdf of pdfContents" lines="none" (click)="downloadPDF(pdf)">
    <ion-label>
      <p class="app-link download-link">{{pdf.title}}</p>
    </ion-label>
  </ion-item>
</ion-content>